export default "__VITE_PUBLIC_ASSET__46c18e1d__"